<div class="empty-state" role="status">
  <i [class]="icon" aria-hidden="true"></i>
  <h3>{{ title }}</h3>
  <p *ngIf="message">{{ message }}</p>
  <button *ngIf="actionLabel" pButton type="button" class="p-button-outlined" [label]="actionLabel" (click)="action.emit()"></button>
</div>